import { Component, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IwgSelect } from 'src/app/shared/models/iwgselect.model';
import { IwgSelectService } from 'src/app/shared/services/iwgselect.service';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {IWGSharedService} from '../../../shared/services/shared.service';

const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => WorkerSelectComponent),
  multi: true
};

@Component({
  selector: 'app-worker-select',
  templateUrl: './worker-select.component.html',
  styleUrls: ['./worker-select.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class WorkerSelectComponent implements ControlValueAccessor,OnChanges {

  @Input("preselected-item-id") preselectedItemId:any;
  @Input("refresh-on-preselect") refreshOnPreselect:boolean;
  @Input("filter-item-id-NOT") filterItemIdNOT;
  @Input("is-required") required:boolean = false;
  @Input("service-type-id") serviceTypeId;
  @Input("disabled") disabled:boolean = false;

  isLoading:boolean = false;
  isOpen:boolean = false;
  items:IwgSelect[] = [];
  WorkerLabel:string = "Worker";
  WorkerLabelLC:string = "Worker";
  WorkerLabelScope:string = "Worker";
  showCompanyName:boolean = false;

  constructor(private selectService: IwgSelectService, private sharedService: IWGSharedService) {
    sharedService.workertitlecontractor.subscribe(() => {

      this.WorkerLabel = 'Contractor';
      this.WorkerLabelLC = 'contractor';
      this.showCompanyName = true;
      this.WorkerLabelScope = 'Contractor';
    });
    sharedService.workerselecttoupdateaorcompliance.subscribe(() => {
      this.WorkerLabel = 'Contractor';
      this.WorkerLabelLC = 'contractor';
      this.showCompanyName = true;
      this.WorkerLabelScope = 'Contractor';
    });
    sharedService.workerselecttoupdateeor.subscribe(() => {
      this.WorkerLabel = 'Worker';
      this.WorkerLabelLC = 'worker';
      this.WorkerLabelScope = 'Worker';
    })
  }

  ngOnChanges(changes: SimpleChanges){
    if (this.serviceTypeId == 3 || this.serviceTypeId == 2) {            
      this.WorkerLabel = 'Contractor';
      this.WorkerLabelLC = 'contractor';
      this.showCompanyName = true;
      this.WorkerLabelScope = 'Contractor';
    }
    if ('preselectedItemId' in changes) {
        if(this.preselectedItemId){
          this.get(true);
        }
    }
  }

  private innerValue: any = '';
  get value(): any {return this.innerValue;};
  set value(v: any) {
      if (v !== this.innerValue) {
        this.innerValue = v;this.onChangeCallback(v);
      }
  }
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;
  writeValue(value: any) {if (value !== this.innerValue) { this.innerValue = value;}}
  registerOnChange(fn: any) {this.onChangeCallback = fn;}
  registerOnTouched(fn: any) {this.onTouchedCallback = fn;}

  onOpen(event){
    this.isOpen = event;
    if(!event || this.items.length>0){
      return;
    } 
    this.isLoading = true;
    this.get();
  }
  get(setId=false){
    this.selectService.getWorkers().subscribe(
      data=>{
        this.isLoading = false;
        this.items = data.data.Data;
        if(this.preselectedItemId != null && setId){
          this.value = this.items.find(item=>item.ID == this.preselectedItemId)
        }
      },
      err=>{
        this.isLoading = false;
        console.log(err);
      }
    );
  }
  objectComparison = function( option, value ) : boolean {
    if (!option || !value) {
      return false;
    }
    return option.ID === value.ID;
  }
}
